import { Grid, Typography } from "@mui/material"
import InfoIcon from '@mui/icons-material/Info';


type props = {
    children : string
    type : string
    isMobile : boolean
}


const AlertMessage : React.FC<props> = (props) => {

    const type = {
        active: props.type === 'active',
        history: props.type === 'history',
        invalid: props.type === 'invalid'
    }

    const backgroundColor = type.active ? '#FFF4EC' :
                            type.history ? '#EEF2FA' :
                            '#FFE0E0'

    const fontColor = type.active ? '#B95000' :
                      type.history ? '#2E5AAC' :
                      '#FE6767'

    return (
        <Grid item style={{width: '100% !important',backgroundColor: backgroundColor, borderRadius : '8px', padding : '0.5em', color: fontColor, display: 'flex'}}>
            <InfoIcon fontSize="small" sx={{position: 'relative', top: '1px'}}/> 
            <Typography color={fontColor} marginLeft={'0.5em'}>
                {props.children}
            </Typography>
        </Grid>
    )
}


export default AlertMessage

